var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpgrade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.397 0a1.748 1.748 0 00-1.269.533l-3.6 3.6a1.8 1.8 0 00-.225 2.27l7.203 10.8a1.8 1.8 0 002.988 0l7.203-10.8a1.8 1.8 0 00-.227-2.27l-3.6-3.6A1.747 1.747 0 0012.6 0H5.398zm-3.93 6.015l5.792 8.673-3.482-8.673h-2.31zm12.75 0l-3.479 8.672 5.792-8.673h-2.312zm-4.625 0v8.284l3.314-8.284H9.592zm-4.5 0l3.314 8.284V6.015H5.092zM1.55 4.808h2.17l.593-2.742-2.763 2.742zm3.398 0h2.824l-2.23-2.823-.594 2.823zm5.28 0h2.824l-.655-2.823-2.17 2.823zm4.05 0h2.169l-2.822-2.823.653 2.823zm-2.804-3.6H6.46l2.54 3.229 2.474-3.23z",
    fill: "url(#upgrade_svg__paint0_linear_562_45749)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "upgrade_svg__paint0_linear_562_45749",
    x1: 9,
    y1: 0.001,
    x2: 9,
    y2: 17.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17BED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#746DE4"
  })))));
}
export default SvgUpgrade;